import apiClient from './apiClient';

// ============================================================
// Types -- matching backend Go models
// ============================================================

export interface F11J {
  f11j_01: string;        // 工繳代號 (PK part 1, max 6 chars)
  f11j_02: string;        // 品質要求代號 (PK part 2, max 2 chars)
  f11j_11: string;        // 品質要求說明
  f11j_91: string;        // 建立人員代號
  f11j_92: string | null; // 建立/修改日期
  f11j_93: string;        // 修改人員代號
}

export interface CreateRequest {
  f11j_01: string;
  f11j_02: string;
  f11j_11: string;
}

export interface UpdateRequest {
  f11j_11: string;
}

export interface ListResponse {
  data: F11J[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const procQualityApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/proc-quality', { params });
    return res.data;
  },

  async get(procCode: string, qualCode: string): Promise<F11J> {
    const res = await apiClient.get(`/api/proc-quality/${encodeURIComponent(procCode)}/${encodeURIComponent(qualCode)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<F11J> {
    const res = await apiClient.post('/api/proc-quality', data);
    return res.data;
  },

  async update(procCode: string, qualCode: string, data: UpdateRequest): Promise<F11J> {
    const res = await apiClient.put(`/api/proc-quality/${encodeURIComponent(procCode)}/${encodeURIComponent(qualCode)}`, data);
    return res.data;
  },

  async delete(procCode: string, qualCode: string): Promise<void> {
    await apiClient.delete(`/api/proc-quality/${encodeURIComponent(procCode)}/${encodeURIComponent(qualCode)}`);
  },
};
